import { combineReducers } from "redux";
import  acct from '../AcctMgt/reducer'
import  ftp from '../FTPMgt/reducer'
export default combineReducers({
    acct, ftp
})